import routes from '@routes';
import mergeWith from 'lodash/mergeWith';

const parseParentsRecursive = (items, parents = [], parent = null) => {
  items.forEach(i => {
    if (i.children) parents = parseParentsRecursive(i.children, parents, i.name);
    let p = parent;
    if (i.meta && i.meta.parent) p = i.meta.parent;
    parents[i.name] = p;
  });
  return parents;
};

const parseFlatRoutesRecursive = items => {
  const names = {};
  items.forEach(i => {
    if (i.children) Object.assign(names, parseFlatRoutesRecursive(i.children));
    names[i.name] = i;
  });
  return names;
};

export const parents = parseParentsRecursive(routes);

export const flatRoutes = parseFlatRoutesRecursive(routes);

const parseBubbleMeta = () => {
  const metas = {};
  Object.keys(flatRoutes).forEach(key => {
    const path = [];
    let name = key;
    while (parents[name]) {
      path.unshift(name);
      name = parents[name];
    }
    if (path.length === 0) {
      path.push(name);
    }
    const meta = {
      path,
      group: flatRoutes[path[0]].meta && flatRoutes[path[0]].meta.parent,
    };
    path.forEach(n => {
      mergeWith(meta, flatRoutes[n].meta, (a, b) => (Array.isArray(a) ? a.concat(b) : b));
    });
    metas[key] = meta;
  });
  return metas;
};

/**
 * Metas are merged recursivly in an hierarchic order as shown in the breadcrumb
 */
export const metas = parseBubbleMeta();

/**
 * Navigation items get only merged rights from real parents (not hierarchical)
 */
export const parseNavigationItems = (items, parentRights = []) => {
  let navigation = [];
  items.forEach(i => {
    let rights = parentRights;
    if (i.meta) {
      if (i.meta.rights) rights = rights.concat(i.meta.rights);
      if (i.meta.navigation) {
        navigation.push({
          name: i.name,
          rights, // merged with parent rights
          parent: i.meta.parent,
        });
      }
    }
    if (i.children) navigation = navigation.concat(parseNavigationItems(i.children, rights));
  });
  return navigation;
};

export const navigationItems = parseNavigationItems(routes);

/**
 * remove navigation items with insufficient rights
 * @param store
 */
export const getVisibleNavigationItems = store => navigationItems.filter(n => !n.rights || !n.rights.some(r => !store.getters['system/hasRight'](r)));
